import axios from 'axios';
import parse from 'date-fns/parse';
import { compose, replace } from 'ramda';
import { getInterval } from '../utils/time';
import { fulfilled } from '../utils/helpers';

export const types = {
  FETCH_TIME_BOUNDS: 'FETCH_TIME_BOUNDS',
};

// export const fetchTimeBounds = () => ({
//   type: types.FETCH_TIME_BOUNDS,
//   payload: axios
//     .get('/timespan')
//     .then(response =>
//       apply(
//         getInterval,
//         response.data.data.map(compose(parse, replace('Z', ''))),
//       ),
//     ),
// });

export const fetchTimeBounds = () => ({
  type: types.FETCH_TIME_BOUNDS,
  payload: axios.get('/safe_timespans').then(response => {
    const { murders, shootings } = response.data.data;
    const murderInterval = getInterval(
      ...murders.map(compose(parse, replace('Z', ''))),
    );
    const shootingInterval = getInterval(
      ...shootings.map(compose(parse, replace('Z', ''))),
    );
    return {
      murders: murderInterval,
      shootings: shootingInterval,
    };
  }),
});

// HACK: to avoid checking for null everywhere
export const initialState = {
  murders: null,
  shootings: null,
};

export default (state = initialState, { type, payload }) =>
  type === fulfilled(types.FETCH_TIME_BOUNDS) ? payload : state;

export const getTimeBounds = state => state.timeBounds.murders;
export const getAllTimeBounds = state => state.timeBounds;



// WEBPACK FOOTER //
// ./src/reducers/timeBounds.js